import * as React from 'react'
import { BIZ_TRADE_SCENE_TYPE, FRONT_PAYMENT_ACTION_TYPE } from '@Pages/member/constant/pay'
import { ValueItem } from '@/common/@types'

interface Props {
  payComponentData: PayComponentData
  onPayComponentCallback?: (event: PayComponentCallbackEvent) => void
}

export enum BizType {
  SailorPreCashier = 'sailor_pre_cashier',
}

export interface PayComponentData {
  bizType: BizType
  bizData?: {
    tradeScene: BIZ_TRADE_SCENE_TYPE
  }
}

export interface PayComponentCalledEvent {
  payAction: string // 对应的业务场景
  payData?: any // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
}

export interface PayComponentCallbackEvent {
  payAction: ValueItem<typeof FRONT_PAYMENT_ACTION_TYPE> // 对应的业务场景
  payData?: any // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
}

class PayComponent extends React.PureComponent<Props, any> {
  payRef: React.RefObject<any> = React.createRef()

  // eslint-disable-next-line react/no-unused-class-component-methods
  callPayComponent = (event: PayComponentCalledEvent) => {
    console.log('给支付event', event)
    this.payRef.current.callPayComponent(JSON.stringify(event))
  }

  render () {
    const { payComponentData, onPayComponentCallback } = this.props
    return <pay-component ref={this.payRef} payComponentData={payComponentData} onPayComponentCallback={onPayComponentCallback}></pay-component>
  }
}

export default PayComponent
